import React from "react";
import tw from "twin.macro";

import { Subheading, Paragraph, SectionHeading } from "../MiscStyles/Headings";
import { PrimaryButton, Link2 } from "../MiscStyles/Buttons";

const Container = tw.div`relative my-20`;
const FlexContainer = tw.div`md:flex md:mx-72 mx-10`;
const LeftContainer = tw.div` md:w-1/2  `;
const RightContainer = tw.div` md:w-1/2  `;

export default () => {
  return (
    <Container>
      <FlexContainer>
        <LeftContainer>
          <SectionHeading style={{ marginBottom: 10 }}>DREAM</SectionHeading>
          <SectionHeading style={{ marginBottom: 10 }}>DESIGN</SectionHeading>
          <SectionHeading>CONSTRUCT</SectionHeading>
        </LeftContainer>

        <RightContainer>
          <Subheading>OUR VISION</Subheading>
          <Paragraph>
            You are passionate about your business, life and work every day to
            make it a success. <br /> <br /> You have a vision of where you want
            to go next. <br /> <br /> To take your dream from a vision to
            reality, you are going to need a partner that understands the scope
            of your project and has the expertise to get the job done.
          </Paragraph>
          <PrimaryButton href="/About">OUR STORY</PrimaryButton>
        </RightContainer>
      </FlexContainer>
    </Container>
  );
};
